<template>
  <div id="maps" class="panel-map">
    <b-card
      class="mx-2"
      bg-variant="secondary"
      text-variant="black"
      header-tag="header"
      footer-tag="footer"
    >
      <b-card-text class="text-left">
        <b-row>
          <b-col lg="7" md="10" sm="12">
            <input-search-location />
          </b-col>
        </b-row>
        <grid-location :collums="colluns()" :per-page="perPage()" />
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import GridLocation from "./GridLocations";
import InputSearchLocation from "./InputSearchLocation";
import { mapGetters } from "vuex";

export default {
  name: "PanelLocation",
  components: {
    InputSearchLocation,
    GridLocation
  },
  computed: {
    ...mapGetters(["municipiosFiltereds"])
  },
  methods:{
    perPage: function () {
      return 12
    },
    colluns: function () {
      return 3
    },
  }
};
</script>

<style>

  .panel-map {
    right: 10px;
    z-index: 40;
    position: absolute;
    top: 100px;
    width: 880px;
  }

  @media only screen and (max-width: 800px) {
    .panel-map {
      right: 0 !important;
      top: 80px !important;
      width: -webkit-fill-available !important;
    }
  }

  @media only screen and (min-width: 1920px) {
    .panel-map {
      width: 1065px !important;
      top: 102px !important;
    }
  }

  @media only screen and (max-width: 500px){
    .section-mapa {
      height: 1230px !important;
    }
  }

</style>
